import "./App.css";
import Home from "./pages/Home";

function App() {
  return (
    <div className="min-h-screen bg-maroBackground text-black">
      <Home />
    </div>
  );
}

export default App;
